// "weekday" -> "Weekday", "weekend" -> "Weekend"; anything else/missing -> null.
export function formatScheduleType(scheduleType) {
  const normalized = String(scheduleType || '').trim().toLowerCase();
  if (!normalized) return null;
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

// Groups a flat student-attendance list (as returned by
// GET /admin/dashboard/student-attendance) by course, then by batch.
// Batches within a course are ordered by their weighted average attendance
// percentage, highest to lowest; students within a batch are ordered by
// their own percentage, highest to lowest.
export function groupStudentsByCourseAndBatch(students) {
  const courseMap = new Map();

  (students || []).forEach((s) => {
    const courseKey = s.courseId != null ? `id-${s.courseId}` : `name-${s.courseName || 'unknown'}`;
    if (!courseMap.has(courseKey)) {
      courseMap.set(courseKey, {
        courseId: s.courseId,
        courseName: s.courseName,
        courseShortName: s.courseShortName,
        scheduleType: s.scheduleType,
        batches: new Map(),
      });
    }
    const course = courseMap.get(courseKey);

    const batchKey = s.batchId;
    if (!course.batches.has(batchKey)) {
      course.batches.set(batchKey, {
        batchId: s.batchId,
        batchName: s.batchName,
        batchInternalName: s.batchInternalName,
        whatsappGroupName: s.whatsappGroupName,
        students: [],
        totalClasses: 0,
        attendedClasses: 0,
      });
    }
    const batch = course.batches.get(batchKey);
    batch.students.push(s);
    batch.totalClasses += s.totalClasses || 0;
    batch.attendedClasses += s.attendedClasses || 0;
  });

  return Array.from(courseMap.values())
    .map((course) => {
      const batches = Array.from(course.batches.values())
        .map((batch) => ({
          ...batch,
          students: [...batch.students].sort((a, b) => (b.overallPercentage ?? -1) - (a.overallPercentage ?? -1)),
          avgPercentage: batch.totalClasses > 0
            ? Math.round((batch.attendedClasses / batch.totalClasses) * 1000) / 10
            : null,
        }))
        .sort((a, b) => (b.avgPercentage ?? -1) - (a.avgPercentage ?? -1));
      return { ...course, batches };
    })
    .sort((a, b) => (a.courseShortName || a.courseName || '').localeCompare(b.courseShortName || b.courseName || ''));
}
